// extracted by mini-css-extract-plugin
export const listHours = "storeHours-module--list-hours--1MyZX";
export const linkContactPage = "storeHours-module--linkContactPage--2J-ul";